import Vue from 'vue'

import { Prop } from 'vue-property-decorator'
import { Mixin } from 'vue-mixin-decorator'

@Mixin
export class Alignable extends Vue {

  @Prop({ required: false })
  align: 'left' | 'right' | 'center' | 'justify'

  protected get alignableStyles () {
    let styleClasses = ['alignable']

    if (this.align) {
      styleClasses.push('align-' + this.align)
    }

    return styleClasses
  }

}
